import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useEffect } from "react";
import { View } from "react-native-ui-lib";
import { Page } from "@towersystems/roam-common-native";
import { RegisterRootParamList } from "../../../../types";
import { Cart } from "../../components/Cart";
import { useSaleControllerProvider } from "../../utils/sale-controller";
import { CartProvider } from "../../components/Cart/CartProvider";
import { ScrollView } from "react-native";
export type MobileCartScreenProps = NativeStackScreenProps<
  RegisterRootParamList,
  "MobileCartScreen"
>;
export const MobileCartScreen = ({ navigation }: MobileCartScreenProps) => {
  const { sale } = useSaleControllerProvider();
  useEffect(() => {
    if (!sale) {
      navigation.goBack();
    }
  }, [sale]);
  const cartMarkup = sale ? (
    <View
      style={{
        flex: 1,
        borderRadius: 8,
      }}
    >
      <ScrollView
        style={{ flex: 1 }}
        nestedScrollEnabled={true}
        contentContainerStyle={{ flexGrow: 1 }}
      >
        <Cart.Header />
        <Cart.Body />
      </ScrollView>
    </View>
  ) : (
    <View />
  );

  if (!sale) {
    return <View />;
  }

  return (
    <CartProvider sale={sale}>
      <Page
        scrollable={true}
        footer={
          <View>
            <Cart.Totals />
            <Cart.Footer />
          </View>
        }
      >
        <View style={{ height: "100%" }} flex>
          {cartMarkup}
        </View>
      </Page>
    </CartProvider>
  );
};
